module.exports = __webpack_public_path__ + "img/overseas-service3.5e1aa055.png";